import styled from 'styled-components';
import RichText from '../rich-text';

export const ModuleWrapper = styled.section`
  margin-bottom: ${({ theme, $backgroundColor }) =>
    $backgroundColor === 'grey' ? 0 : theme.spacing.medium};
  background-color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'white' && theme.palette.white) ||
    ($backgroundColor === 'grey' && theme.palette.lightBackground)};
`;

export const StyledRichText = styled(RichText)`
  h1,
  h2,
  h3,
  h4 {
    &:first-of-type {
      margin-top: 0;
    }
  }
`;
